import type { Step } from "react-joyride";

export const promotionRulesTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ສະແດງກົດເສັ້ນທາງການເລື່ອນຕຳແໜ່ງ. ທ່ານສາມາດກັ່ນຕອງຕາມຕຳແໜ່ງ ແລະ ສະຖານະ, ເພີ່ມ rule ໃໝ່ ຫຼື ແກ້ໄຂ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="promotion-rules-toolbar"]',
    content:
      "ກົດ 'ເພີ່ມຂໍ້ກຳນົດການເລື່ອນຕຳແໜ່ງ' ເພື່ອສ້າງກົດເສັ້ນທາງໃໝ່. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-rules-filter"]',
    content:
      "ເລືອກຈາກຕຳແໜ່ງ, ໄປຕຳແໜ່ງ, ສະຖານະ (ເປີດ/ປິດ) ແລະ ຄົ້ນຫາເພື່ອກັ່ນຕອງລາຍການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-rules-table"]',
    content:
      "ຕາຕະລາງຂໍ້ກຳນົດການເລື່ອນຕຳແໜ່ງ. ກົດແຖບຫຼືປຸ່ມແກ້ໄຂເພື່ອແກ້ໄຂຂໍ້ກຳນົດການເລື່ອນຕຳແໜ່ງ.",
    placement: "top",
  },
];
